import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import  './axios/request' // axios配置
import './directive' // 自定义vue指令
import filter from "../../web/src/filter/filter";
import './assets/css/global.scss' // 全局样式

// 引用element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

//引入vue-qriously
import VueQriously from "vue-qriously";
Vue.use(VueQriously)

// 引入富文本样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

//引入vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/swiper-bundle.css";
Vue.use(VueAwesomeSwiper)
//全局过滤
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
});

//应用表单验证
import ElementValidator from './utils/validator';
Vue.prototype.ElementValidator = ElementValidator;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

//如果在https部署项目，动态将页面的的所有http转为https
if (window.location.href.substr(0,8).toLowerCase() === "https://" && process.env.NODE_ENV === 'production') {
  const head = document.getElementsByTagName('head')[0]
  const meta = document.createElement("meta");
  meta.setAttribute('http-equiv', 'Content-Security-Policy')
  meta.setAttribute('content', 'upgrade-insecure-requests')
  head.appendChild(meta)
}
